// AuthContext.js
import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';
import {jwtDecode} from 'jwt-decode';
import { setAuthToken } from '../service/Authservice';
import api from '../api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const timerRef = useRef(null);

  const login = async (credentials) => {
    try {
      const response = await api.post('/auth/login', credentials);
      const { accessToken, refreshToken } = response.data;
      localStorage.setItem('authToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      setAuthToken(accessToken);
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    }
  };

  const logout = () => {
    // Cancella il timer se attivo
    if (timerRef.current) clearTimeout(timerRef.current);
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    setAuthToken(null);
    setIsAuthenticated(false);
  };

  const refreshToken = useCallback(async () => {
    const storedRefreshToken = localStorage.getItem('refreshToken');
    if (!storedRefreshToken) {
      setIsAuthenticated(false);
      return;
    }
    try {
      const response = await api.post(
        '/auth/refresh-token',
        { refreshToken: storedRefreshToken },
        { skipLoading: true }
      );
      localStorage.setItem('authToken', response.data.accessToken);
      setAuthToken(response.data.accessToken);
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const storedRefreshToken = localStorage.getItem('refreshToken');

    if (token && storedRefreshToken) {
      setIsAuthenticated(true);
      setAuthToken(token);
      try {
        const decoded = jwtDecode(token);
        const exp = decoded.exp * 1000; // tempo di scadenza in ms
        const now = Date.now();
        const timeout = exp - now - 60000; // 1 minuto prima della scadenza
        if (timeout > 0) {
          timerRef.current = setTimeout(() => {
            refreshToken();
          }, timeout);
        } else {
          refreshToken();
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    // Pulizia: in caso di smontaggio, cancella il timer
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [refreshToken]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
